import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { AnnouncementData } from "../types/AnnoucementData";
import DraggableModal from "common/components/molecules/DraggableModal";
import { CancelButton } from "common/components/atoms/CancelButton";
import { safeApiDate } from "utils/DateTools";

export type Props = {
  open: boolean;
  data: AnnouncementData;
  closeClicked: () => void;
};

export const AnnouncementModal = (props: Props) => {
  const { open, data } = props;
  return (
    <Modal show={open} dialogAs={DraggableModal} size="lg">
      <Modal.Body>
        <SModalContent>
          <SHeader className="handle">
            <STitle className="fs-5 fw-bold text-primary mb-2">{data.title}</STitle>
            <SDateContainer>
              <SDateLabel className="small text-muted me-2">公開日:</SDateLabel>
              <SDate className="small text-secondary">
                {safeApiDate(data.publishDate).toLocaleDateString("ja-JP")}
              </SDate>
            </SDateContainer>
          </SHeader>

          <SContentSection>
            <SContentLabel className="text-dark mb-2">内容</SContentLabel>
            <SContent className="fs-6 text-dark">
              {data.contents || "お知らせの内容がありません。"}
            </SContent>
          </SContentSection>
        </SModalContent>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={props.closeClicked} text={"閉じる"} style={{ minWidth: "100px" }} />
      </Modal.Footer>
    </Modal>
  );
};

const SModalContent = styled.div`
  padding: 8px 0;
`;

const SHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const STitle = styled.div`
  line-height: 1.4;
  margin-top: 8px;
  cursor: move; /* ドラッグ可能であることを示す */
`;

const SDateContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

const SDateLabel = styled.span`
  font-weight: 500;
`;

const SDate = styled.span`
  font-weight: 400;
`;

const SContentSection = styled.div`
  margin-top: 16px;
`;

const SContentLabel = styled.div`
  margin-bottom: 8px;
  color: #495057;
`;

const SContent = styled.div`
  padding: 12px;
  word-wrap: break-word;
  white-space: pre-wrap; /* 改行とスペースを保持 */
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  min-height: 200px;
  max-height: 400px;
  overflow: hidden;
  overflow-y: auto;
`;
